import { useState } from 'react';

function useDraggable(id) {
  var _useState = useState(false),
    isDragging = _useState[0],
    setIsDragging = _useState[1];
  var handleDragStart = function handleDragStart(event) {
    event.dataTransfer.setData('text/plain', id);
    event.dataTransfer.dropEffect = 'move'; // eslint-disable-line no-param-reassign
    setIsDragging(true);
  };
  var handleDragEnd = function handleDragEnd() {
    setIsDragging(false);
  };
  return {
    isDragging: isDragging,
    draggableProps: {
      id: id,
      draggable: 'true',
      onDragStart: handleDragStart,
      onDragEnd: handleDragEnd
    }
  };
}

export { useDraggable };
